import { ReactComponent as CloseIcon } from "../../icons/close.svg";
import { CMCloseButton } from "../place-bid/place-bid/place-bid.styles";
import WizardModalStep from "../wizard-modal/wizard-modal-step/wizard-modal-step.component";
import { CMUploadModal } from "./upload-files.styles";
import { useEffect, useState } from "react";
import { apiUrlDomain } from "../../Utils/api.utils";

const UploadFileContactUS = ({ open, handleClose, title, userId, entryId, assetDetailsId, itemId, handleSaveFile, setFileUrl }) => {
    const [localFileUrl, setLocalFileUrl] = useState('');

    useEffect(() => {
        window.addEventListener(
            "message",
            (event) => {
                if (!event.data) return;
                try {
                    const receivedFileUrl = JSON.parse(event.data);
                    setLocalFileUrl(receivedFileUrl);
                } catch (e) {
                    console.error("Error parsing message from iframe", e);
                }
            },
            false,
        );

        return () => {
            window.removeEventListener("message", () => {});
        };
    }, []);

    useEffect(() => {
        if (handleSaveFile) {
            handleSaveFile({ ...localFileUrl, itemId: itemId });
        }

        if (setFileUrl) {
            setFileUrl(localFileUrl);
        }
    }, [localFileUrl]);

    return (
        <CMUploadModal open={open} onClose={handleClose}>
            <CMCloseButton onClick={handleClose}>
                <CloseIcon width={16} height={16} />
            </CMCloseButton>
            <WizardModalStep title={title}>
                <iframe
                    id="myIframe"
                    src={`${apiUrlDomain}/Tools/Upload-Contact-Us/dnnprintmode/true?SkinSrc=%255bG%255dSkins%252f_default%252fNo%2bSkin&ContainerSrc=%255bG%255dContainers%252f_default%252fNo%2bContainer&userId=${userId}&amp;entryid=${entryId}&amp;assetDetailsId=${assetDetailsId}`}
                    width="100%"
                    height="350"
                    frameBorder="0"
                ></iframe>
            </WizardModalStep>
        </CMUploadModal>
    );
};

export default UploadFileContactUS;
